<!--
  naverAth.vue ( 2-2 step, mblElcSgn17 )
  - 네이버 인증
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header type="type_naver" />
    <div class="container type_complete" v-if="nSignAuth">
      <!-- 완료페이지만 : type_complete 클래스 적용 -->
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <div class="finish_wrap case_naver">
            <p>
              네이버인증서 인증이 진행 중입니니다.<br />잠시만 기다려 주세요.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="!nSignAuth">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="txt">
            안전한 가입을 위해 본인인지 확인하고 진행하겠습니다.
          </p>
          <div class="form_wrap" v-if="isRpsMbl">
            <ul>
              <InputArea label="성명" v-model="state.fnm"></InputArea>
              <li>
                <label for="bitrhInput">주민등록번호</label>
                <div class="form_area_multi">
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        type="tel"
                        id="bitrhInput"
                        class="form_input"
                        placeholder="주민등록번호 앞자리"
                        maxlength="6"
                        v-model="state.bdt"
                      />
                    </div>
                    <div class="form_guide">
                      <!-- 에러일 경우 : error 클래스 추가 -->
                      <p class="txt_alert">
                        <span>생년월일을 입력하세요.</span>
                      </p>
                    </div>
                  </div>
                  <div class="hyphen"></div>
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        type="password"
                        id="idfNo"
                        name="idfNo"
                        class="form_input bg_pw"
                        maxLength="7"
                        placeholder="●●●●●●●"
                        ref="idfNoEl"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this);"
                      />
                    </div>
                    <div class="form_guide">
                      <!-- 에러일 경우 : error 클래스 추가 -->
                      <p class="txt_alert">
                        <span>주민등록번호를 입력하세요.</span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <p class="tit">개인(신용)정보처리 동의서</p>
          <ul class="check_agree_list">
            <li>
              <div class="check_box">
                <input
                  type="checkbox"
                  id="checkAll"
                  @click="setAgrChk('allAgr')"
                  :checked="agr.allAgr"
                />
                <label for="checkAll">전체동의</label>
              </div>
            </li>
            <li>
              <div class="check_box">
                <input
                  type="checkbox"
                  id="agr01"
                  @click="setAgrChk('agr01')"
                  :checked="agr.agr01"
                />
                <label for="agr01"
                  >개인(신용)정보의 수집·이용에 관한 동의</label
                >
              </div>
              <button
                type="button"
                class="btn_more"
                @click="openAgrPopup('IndvInfGthUseMtt')"
              >
                <span>더보기</span>
              </button>
            </li>
            <li>
              <div class="check_box">
                <input
                  type="checkbox"
                  id="agr02"
                  @click="setAgrChk('agr02')"
                  :checked="agr.agr02"
                />
                <label for="agr02">개인(신용)정보의 제공에 대한 동의</label>
              </div>
              <button
                type="button"
                class="btn_more"
                @click="openAgrPopup('IndvInfOfrMtt')"
              >
                <span>더보기</span>
              </button>
            </li>
          </ul>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="naverSign">
              <span>네이버 인증서 인증</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { reactive, inject, onMounted, computed, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import InputArea from "@/components/01/InputArea.vue";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";

export default {
  name: "kakaoAth",
  components: {
    Header,
    Footer,
    InputArea,
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const isRpsMbl = computed(() => store.state.elcSgnInf.isRpsMbl);
    const idfNoEl = ref(null);

    const agr = reactive({
      allAgr: false,
      agr01: false,
      agr02: false,
    });

    onMounted(async () => {
      await nextTick();
      await load();
      util.saveLog("009", "네이버인증"); // 009 : 화면진입
      if (!store.state.elcSgnInf.isRpsMbl && sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      } else if (store.state.elcSgnInf.isRpsMbl) {
        transkey = [];
        mtk = null;
        tk_btn_arr = [];
        setTimeout(initmTranskey, 500);
      }

      if (
        !(
          sessionUserInfo.naverAccessToken == "" ||
          util.isNull(sessionUserInfo.naverAccessToken) ||
          util.isEmpty(sessionUserInfo.naverAccessToken)
        )
      ) {
        state.nSignAuth = true;
        if (
          sessionUserInfo.txId == "" ||
          util.isNull(sessionUserInfo.txId) ||
          util.isEmpty(sessionUserInfo.txId)
        ) {
          axios
            .json("/mobAth/retrieveNsignAuth.do", {})
            .then(function (result) {
              if (result.data.standCd == "0000") {
                var pollingPageUrl = result.data.pollingPageUrl;
                window.location.href = pollingPageUrl;
              } else {
                dialog.alert(
                  "네이버인증서 인증 실패하였습니다. 다시 시도해주세요."
                );
                state.nSignAuth = false;
                return;
              }
            });
        } else {
          var param = {};
          param.txId = sessionUserInfo.txId;
          axios
            .json("/mobAth/retrieveNsignResult.do", param)
            .then(function (result) {
              let authResult = result.data.authResult;
              if (authResult == "success") {
                var param1 = {};
                param1.prctrNo = sessionUserInfo.prctrNo;
                param1.athNo = sessionUserInfo.txId;
                param1.ctnsKdCd = sessionUserInfo.ctnsKdCd;
                param1.orgCd = sessionUserInfo.orgCd;
                param1.cusNo = sessionUserInfo.cusNo;
                param1.pcsCtnsSndReqId = sessionUserInfo.dataId;
                param1.elcSgnSelfAthMdCd = "03";

                if (!store.state.elcSgnInf.isRpsMbl) {
                  axios
                    .json("/registPrtblAthNo.do", param1)
                    .then(function (result) {
                      router.push({ name: "ctrBasMttCnf" });
                    });
                } else {
                  store.commit("elcSgnInf/changeAthData", param1);
                  router.push({ name: "ctrLstCho" });
                }
              } else if (authResult == "cancel") {
                dialog.alert(
                  "네이버인증서 인증 취소되었습니다. 다시 시도해주세요."
                );
                state.nSignAuth = false;
                return;
              } else if (authResult == "fail") {
                dialog.alert(
                  "네이버인증서 인증 실패하였습니다. 다시 시도해주세요."
                );
                state.nSignAuth = false;
                return;
              } else if (authResult == "pending") {
                dialog.alert("네이버인증서 인증 대기 중입니다.");
                state.nSignAuth = false;
                return;
              } else {
                dialog.alert(
                  "네이버인증서 인증 실패하였습니다. 다시 시도해주세요."
                );
                state.nSignAuth = false;
                return;
              }
            });
        }
      }
    });

    const state = reactive({
      nSignAuth: false,
      tx_id: "",
    });

    const openAgrPopup = (type) => {
      dialog.lyorPop(
        "01/dialog/" + type + ".vue",
        { isNaver: true },
        { content: "pop_agree" }
      );
    };

    const setAgrChk = (type) => {
      switch (type) {
        case "allAgr":
          if (agr.allAgr) {
            agr.allAgr = false;
            agr.agr01 = false;
            agr.agr02 = false;
          } else {
            agr.allAgr = true;
            agr.agr01 = true;
            agr.agr02 = true;
          }
          break;
        default:
          agr[type] = !agr[type];
          if (agr.agr01 && agr.agr02) agr.allAgr = true;
          else agr.allAgr = false;
          break;
      }
    };

    const naverSign = () => {
      if (!fnValidation()) {
        return false;
      }

      if (store.state.elcSgnInf.isRpsMbl) {
        let inputData = util.getMobileInputEncData(["idfNo"]);
        inputData.title = "idfNo";
        axios.reqPost("/solution/decodeIdf.do", inputData).then((result) => {
          let decodeFlag = result.data.decodeFlag;
          console.log(decodeFlag);
          if (decodeFlag) {
            axios
              .json("/inspe/retrieveMblElcSgnEcusProgInf.do", {
                rcipeIdfNo: state.bdt,
                inqStdDt: state.currDate,
                inqCtnsKdCd: "120445",
                prctrInfInqYn: "1",
                sgnCompInclYn: "",
              })
              .then((res) => {
                if (res.data.mblElcSgnEcusProgInfBcVo.length == 0) {
                  if (res.data.body.length == 0) {
                    dialog.alert(
                      "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                    );
                  } else {
                    // 발송건 조회 실패로 인증 X
                    dialog.alert(
                      "피보험자 전자서명을 진행할 대상 건이 없습니다."
                    );
                  }
                } else {
                  let cusNo = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeCusNo;
                  let cusNm = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeNm;

                  if (cusNm == state.fnm) {
                    store.commit(
                      "elcSgnInf/changeMblElcSgnEcusProgInfBcVo",
                      res.data.mblElcSgnEcusProgInfBcVo
                    );
                    store.commit(
                      "elcSgnInf/changeCusInfo",
                      res.data.cusInfoMap.body
                    );
                    naverSign_step2();
                  } else {
                    dialog.alert(
                      "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                    );
                  }
                }
              });
          }
        });
      } else {
        naverSign_step2();
      }
    };

    const naverSign_step2 = () => {
      let param = {};
      param.inqDivCd = "2";

      axios.json("/cusInfo/getCusInfo.do", param).then(function (result) {
        let cellphoneNo = result.data.body.cellNo;

        param = {};
        param.phoneNo = util.replaceNum(cellphoneNo);
        axios
          .json("/mobAth/retrieveNsignCell.do", param)
          .then(function (result) {
            var standCd = result.data.standCd;
            // var standMsg = result.data.standMsg;
            if (standCd != "9999") {
              if (
                sessionUserInfo.naverAccessToken == "" ||
                util.isNull(sessionUserInfo.naverAccessToken) ||
                util.isEmpty(sessionUserInfo.naverAccessToken)
              ) {
                var url =
                  process.env.VUE_APP_API_URL + "/mblElcSgnNloginReady.do";
                window.location.href = url;
              }
            } else {
              dialog.alert(
                "메리츠화재 전산에 등록된 휴대폰번호와 일치하지 않습니다."
              );
              return;
            }
          });
      });
    };

    function fnValidation() {
      if (store.state.elcSgnInf.isRpsMbl) {
        if (util.isNull(state.fnm) || util.isEmpty(state.fnm)) {
          dialog.alert("성명을 입력해주세요");
          return false;
        } else if (util.isNull(state.bdt) || util.isEmpty(state.bdt)) {
          dialog.alert("주민등록번호를 입력해주세요");
          return false;
        }

        let validBdt = util.replaceNum(state.bdt);

        if (!util.isNumeric(validBdt)) {
          dialog.alert("주민등록번호를 숫자로만 입력해주세요.");
          return false;
        } else if (isRpsMbl && validBdt.length != 6) {
          dialog.alert("주민등록번호 앞자리를 입력해주세요.");
          return false;
        } else if (isRpsMbl && util.isEmpty(idfNoEl.value.value)) {
          dialog.alert("주민등록번호 뒷자리를 입력해주세요.");
          return false;
        }
      }

      if (!agr.agr01 || !agr.agr02) {
        dialog.alert("개인(신용)정보처리 동의를 체크하세요.");
        return false;
      }

      return true;
    }

    return {
      agr,
      state,
      load,
      sessionUserInfo,
      naverSign,
      setAgrChk,
      openAgrPopup,
      isRpsMbl,
      idfNoEl,
    };
  },
};
</script>
